import { useEffect, useState } from 'react'

import {
  useMasterBillActions,
  useMasterBillState
} from '../../stores/useMasterBillStore'

import ConfirmDialog from '@/components/common/ConfirmDialog'
import { useUIStore } from '@/stores/useUIStore'

const HouseBillNote: React.FC = () => {
  const { showSuccess, showError } = useUIStore()
  const { loading, noteDialog, houseBill } = useMasterBillState()
  const { updateNoteByHouseBill, closeNoteDialog } = useMasterBillActions()
  const [editingNote, setEditingNote] = useState('')

  // 保存备注
  const onSubmit = async () => {
    const { success, message } = await updateNoteByHouseBill(editingNote)
    if (success) {
      showSuccess("备注更新成功")
      closeNoteDialog()
      setEditingNote("")
    } else {
      showError(message)
    }
  }

  // 取消编辑备注
  const cancelNoteEdit = () => {
    closeNoteDialog()
    setEditingNote('')
  }

  useEffect(() => {
    if (houseBill?.note) {
      setEditingNote(houseBill.note)
    }
  }, [houseBill])

  return (
    <>
      <ConfirmDialog
        isOpen={noteDialog}
        title="编辑备注"
        confirmText="保存"
        cancelText="取消"
        onConfirm={onSubmit}
        onCancel={cancelNoteEdit}
        isLoading={loading}
        maxWidth="lg"
      >
        <div className="space-y-3">
          <label className="block text-sm font-medium text-gray-700">
            备注内容
          </label>
          <textarea
            value={editingNote}
            onChange={(e) => setEditingNote(e.target.value)}
            placeholder="请输入备注内容..."
            rows={6}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none resize-none"
          />
          <p className="text-xs text-gray-500">
            当前字符数: {editingNote.length}
          </p>
        </div>
      </ConfirmDialog>
    </>
  )
}

export default HouseBillNote
